import React from "react";
// import { useDropzone } from "react-dropzone";
import { SendResaleFiles } from "../../api/methods-marketplace";
import { yupResolver } from "@hookform/resolvers/yup";
// import fileImage from "../../images/file.png";
import {
  Modal,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Select,
  SelectItem,
  addToast
} from "@heroui/react";
import { Controller, useForm } from "react-hook-form";
import { resaleValidation } from "../../utils/yubSchema/validate";
import { useParams } from "react-router-dom";

export const tokensLists = [{ key: "baf", label: "BAF" }];

// const MAX_FILE_SIZE = 24 * 1024 * 1024; // 24MB

const ResalePopup = ({ isOpen, item, onOpenChange, onResaleSuccess }) => {
  const physical_asset = item?.data?.collection?.physical_nft;
  const isPhysicalAsset = physical_asset === "true" || physical_asset === true;
  // const fileInputRef = useRef(null);

  const { slug } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    // setValue,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(resaleValidation),
    defaultValues: {
      resale_price: "",
      token: "baf",
      tracking_id: "",
      is_physical_asset: isPhysicalAsset
      // nft_images: []
    },
    mode: "onSubmit",
    reValidateMode: "onBlur"
  });

  const handleOnClick = async (data) => {
    try {
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (key === "tracking_id" && !isPhysicalAsset) {
            return;
          }

          if (key === "nft_images") {
            if (value instanceof File) {
              formData.append(key, value);
            }
          } else {
            formData.append(key, value.toString());
          }
        }
      });

      const response = await SendResaleFiles(formData, slug);

      if (response?.data?.success) {
        addToast({
          title: "Resale has been submitted successfully.",
          color: "success",
          variant: "solid"
        });

        if (typeof onResaleSuccess === "function") {
          try {
            await onResaleSuccess();
          } catch (err) {
            console.error("onResaleSuccess failed:", err);
          }
        }

        // 2) then close/reset
        reset();
        onOpenChange();
      } else if (response?.data?.errors) {
        addToast({
          title: "Resale has been failed.",
          color: "danger",
          variant: "solid"
        });
        reset();
        onOpenChange();
      } else {
        addToast({
          title: "An error occurred. Please try again later.",
          color: "danger",
          variant: "solid"
        });
        reset();
        onOpenChange();
      }
    } catch (error) {
      console.error("Error resale form:", error);
      reset();
      onOpenChange();
    }
  };

  // const handleImageUploadClick = () => {
  //   if (fileInputRef.current) {
  //     fileInputRef.current.click();
  //   }
  // };

  // const handleOnChangeImage = (event) => {
  //   console.log(event, "event");
  //   const file = event.target.files[0]; // Get the selected file

  //   if (file) {
  //     console.log("Selected file:", file);
  //     if (file.size > MAX_FILE_SIZE) {
  //       addToast({
  //         title: "File size should be less than 24MB",
  //         color: "danger"
  //       });
  //       return;
  //     }
  //     setValue("nft_images", file);
  //   }
  // }

  return (
    <>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <form onSubmit={handleSubmit(handleOnClick)}>
              <ModalBody className="pt-8 gap-5">
                <div className="title-wrapper">
                  <h1 className="m-0 text-3xl text-black font-bold text-center">
                    Resale
                  </h1>
                </div>
                <div className="flex flex-col gap-5">
                  <div className="flex">
                    <div className="w-[calc(100%-6rem)] md:w-[calc(100%-7rem)]">
                      <div className="flex flex-col gap-1">
                        <Input
                          label=""
                          placeholder="Resale Price"
                          {...register("resale_price")}
                          type="text"
                          classNames={{
                            label: "hidden",
                            inputWrapper:
                              "min-h-[3.125rem] h-[3.125rem] rounded-none rounded-s-lg bg-white data-[hover=true]:bg-transparent group-data-[focus=true]:bg-transparent shadow-none border border-[#C2C2C2]"
                          }}
                        />
                        <small className="text-xs block text-red-600">
                          {errors?.price?.message}
                        </small>
                      </div>
                    </div>
                    <div className="w-[6rem] md:w-[7rem]">
                      <div className="flex flex-col gap-1">
                        <Controller
                          name="token"
                          control={control}
                          render={({ field }) => (
                            <Select
                              aria-label="Select Token"
                              selectedKeys={new Set([field.value])}
                              onSelectionChange={(keys) => {
                                const selectedValue = Array.from(keys)[0];
                                field.onChange(selectedValue);
                              }}
                              placeholder="select token"
                              classNames={{
                                label: "hidden",
                                base: "h-full data-[has-label=true]:mt-0",
                                mainWrapper: "h-full",
                                trigger:
                                  "rounded-none rounded-e-lg h-full bg-[#E9E9E9] shadow-none border border-[#C2C2C2] border-l-0 min-h-[3.125rem] h-[3.125rem]"
                              }}
                            >
                              {tokensLists.map((token) => (
                                <SelectItem key={token.key}>
                                  {token.label}
                                </SelectItem>
                              ))}
                            </Select>
                          )}
                        />
                        <small className="text-xs block text-red-600">
                          {errors?.token?.message}
                        </small>
                      </div>
                    </div>
                  </div>
                  {isPhysicalAsset && (
                    <div className="flex flex-col gap-1">
                      <Input
                        label=""
                        placeholder="Track ID"
                        {...register("tracking_id")}
                        type="text"
                        classNames={{
                          base: "data-[has-label=true]:mt-0",
                          label: "hidden",
                          inputWrapper:
                            "min-h-[3.125rem] h-[3.125rem] rounded-none rounded-lg bg-white data-[hover=true]:bg-transparent group-data-[focus=true]:bg-transparent shadow-none border border-[#C2C2C2]"
                        }}
                      />
                      <small className="text-xs block text-red-600">
                        {errors?.trackId?.message}
                      </small>
                    </div>
                  )}
                  {/* <div className="flex flex-col gap-1">
                    <input type="file" className="hidden" ref={fileInputRef} accept="image/*" onChange={(e)=>handleOnChangeImage(e)}/>
                    <div className="flex flex-col gap-8 border border-[#C2C2C2] p-4 rounded-xl cursor-pointer" onClick={handleImageUploadClick}>
                      <div className="flex flex-col gap-1">
                        <h2 className="m-0 text-lg font-semibold text-black">Upload Images</h2>
                        <p className="m-0 text-sm text-[#6A6A6A] leading-[1.6] font-albert">
                        Please upload files in jpg, jpeg or png format and make sure the file size is under 25 MB.
                        </p>
                      </div>
                      <div className="flex flex-wrap gap-4">
                        <div className="p-4 rounded-lg border border-[#FCEDFD] flex flex-col gap-1.5 items-center">
                          <Image
                            src={fileImage}
                            alt="file"
                            className="w-[1.625rem] h-[2.625rem] object-contain"
                            radius="none"
                          />
                          <p className="m-0 text-sm text-black font-normal">File.png</p>
                        </div>
                      </div>
                      <div className="bg-[#F4F4FF] p-2 rounded-lg border border-dashed	border-[#0000FF] flex flex-col gap-1">
                        <h6 className="m-0 text-base font-medium text-center font-dm">Drop file or <span className="text-[#0000FF]">Browse</span></h6>
                        <p className="m-0 text-sm text-[#6A6A6A] text-center font-dm">Format: png, jpeg, jpg & Max file size: 25 MB</p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="submit"
                  color="primary"
                  radius="none"
                  className="bg-yellowbuy text-black px-16 mx-auto border border-black rounded-lg max-w-[13.75rem] w-full"
                >
                  Submit
                </Button>
              </ModalFooter>
            </form>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default ResalePopup;
